import { adminConfig } from "../utils/adminConfig";
import axios from "./axios";

export const saveAffiliate = (url = "/affiliate/save", data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, adminConfig())
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((err) => {
        reject(err.response.data.message);
      });
  });
};
export const getAffiliates = (url = "/affiliate/get", data) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((err) => {
        reject(err.response.data.message);
      });
  });
};
export const getAffiliatesWithPagination = (url = "/affiliate/get", page = 1, limit = 10) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url + "?page=" + page + "&limit=" + limit)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err.response.data.message);
      });
  });
};
export const getAffiliateURL =
  () =>
    (code, data = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get("/affiliate/get-url/" + code, data)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((err) => {
            reject(err.response.data.message);
          });
      });
    };
export const increaseHits =
  () =>
    (url = "/affiliate/hits", data) => {
      return new Promise((resolve, reject) => {
        axios
          .post(url, data)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((err) => {
            reject(err.response.data.message);
          });
      });
    };

export const saveCommissionPlan = (url = "/commission-plan", data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, adminConfig())
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((err) => {
        reject(err.response.data.message);
      });
  });
};

export const getCommissionPlan = () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/commission-plan-list")
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((err) => {
        reject(err.response.data.message);
      });
  });
};
